import { EventDataEvents } from "../Consts";
import { EulerStateManager } from "../EulerStateManager";
import { EventData } from "../EventData";
import { BaseState } from "../States/BaseState";

import { EventFetcher } from "../../utils/EventFetcher";
import { Gamesocket } from "../../utils/Gamesocket";
import { validateData } from "../../utils/validators";
import { ValidatedData } from "../../utils/validators";



import config from "../../../game.config.json";

class GetNextEvent extends BaseState<EulerStateManager> {
  public id = "GetNextEvent";
  constructor(stateManager: EulerStateManager) {
    super(stateManager); // Pass the StateManager to the base class
    this.bindEvents();
    this.subscribeToEvents();
  }

  private async initData(
    validator: (data: any, sportType: string) => ValidatedData,
  ) {
    console.log("INIT DATA");
    const fetchCurrentEvent = new EventFetcher({
      channelID: config.channel,
      url: config.URL,
    });
    const nextEvent = await fetchCurrentEvent.fetchEvent("next");
    if (!nextEvent) {
      console.log("Failed to fetch next event");

      return;
    }
    Gamesocket.getInstance(config.URL, nextEvent.id, {
      onMessage(data) {
        const validData = validator(data, config.sportType);
        const eventData = EventData.getInstance();
        if (!validData.isValid) {
          console.warn(`Invalid ${config.sportType} data from socket: `, data);
          return;
        }
        if (!validData.data) return;

        eventData.parseDataBasedOnState(validData.data);

        // dataParser(validData.data);
      },
    });
  }

  public onEnter(stateManager: EulerStateManager): void {
    this.stateManager = stateManager; // Set the StateManager reference
    super.onEnter(stateManager); // Call the super method
    this.stateManager.onEnterGetNextEventState();

    // console.debug('EVENT DATA: ', eventData);

    this.initData(validateData);
  }

  private bindEvents() {
    this.transition = this.transition.bind(this);
  }

  private subscribeToEvents() {
    const eventData = EventData.getInstance();
    eventData.subscribeToEvent(
      EventDataEvents.ON_DATA_ASSIGNED,
      this.transition,
    );
  }

  public transition(): void {
    if (this.stateManager?.getCurrentStateID() === "GetNextEvent") {
      this.stateManager?.changeState(
        this.stateManager.eulerLoadAndShowOddsState,
      );
    }
  }

  public onExit(): void {
    super.onExit();
  }
}

export { GetNextEvent };
